import {
  Button,
  Dropdown,
  DropdownBody,
  DropdownButton,
  DropdownItem,
} from "@components";
import { Funnel } from "react-bootstrap-icons";

const FiltersButton = ({
  filters,
  managedColumns,
  onAddFilter,
  getColTitle,
}) => {
  return (
    <Dropdown>
      <DropdownButton>
        <Button color="secondary" aria-label="Filters" title="Filters" className="h-8">
          <Funnel />
        </Button>
      </DropdownButton>

      <DropdownBody>
        {managedColumns
          .filter((x) => x.type)
          .map((x) => (
            <DropdownItem
              closeOnComplete
              key={x.key}
              disabled={filters.some((y) => y.key === x.key)}
              onClick={() => onAddFilter(x.key)}
            >
              {getColTitle(x)}
            </DropdownItem>
          ))}
      </DropdownBody>
    </Dropdown>
  );
};

export default FiltersButton;
